var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 .333C8.703.333.333 8.711.333 18.999c0 10.297 8.37 18.667 18.667 18.667 10.289 0 18.666-8.37 18.666-18.667C37.666 8.711 29.29.333 19 .333zm7.474 19.257l-11.05 8.527a.732.732 0 01-.456.157.844.844 0 01-.328-.075.756.756 0 01-.418-.672V10.481c0-.291.164-.545.418-.672a.745.745 0 01.784.075l11.05 8.526c.18.142.291.359.291.59a.757.757 0 01-.291.59z",
    fill: "#fff"
  })));
};
export default SvgPlay;